import { useLocation } from "react-router-dom";

/**
 * Custom hook to get current screen name for analytics tracking
 * Maps route paths to friendly screen names
 * 
 * @returns {string} Screen name for tracking (e.g., "home", "carrinho", etc.)
 */
export const useScreenTracking = () => {
  const location = useLocation();
  
  const getScreenName = () => {
    const pathname = location.pathname;
    const cleanPath = pathname.replace(/^\/loja\/?/, "");

    if (cleanPath.startsWith("product/")) {
      const productId = cleanPath.split("/")[1];
      return productId ? `pdp-${productId}` : "pdp";
    }
    
    if (cleanPath.startsWith("category/")) {
      return "vitrine-categorias";
    }
    
    if (cleanPath.startsWith("brands/")) {
      return "vitrine-marcas";
    }
    
    if (cleanPath.startsWith("orderresumestatus/")) {
      return "resumo-da-compra";
    }
    
    if (cleanPath.startsWith("products/")) {
      return "resultado-da-busca";
    }

    const staticRoutes = {
      "": "home",
      "categories": "lista-categorias",
      "brands": "lista-marcas",
      "orderresume": "carrinho",
      "orderresumepag": "resumo-da-compra",
      "favorites": "favoritos",
      "myaccount": "minha-conta",
      "myrequests": "meus-pedidos",
      "orderplaced": "pedido-realizado-com-sucesso",
      "ordernotapproved": "pedido-nao-aprovado",
      "orderplacedsuccessfully": "pedido-realizado-com-sucesso",
      "passagens-aereas": "passagens-aereas",
      "hoteis": "hoteis",
      "search-travel": "busca-viagem",
      "search-hotels-result": "resultado-hoteis",
      "search-cars-result": "resultado-carros",
      "policy": "termos-e-condições",
      "exchange": "politica-troca",
      "error": "erro",
      "notFound": "pagina-nao-encontrada"
    };

    const normalizedPath = cleanPath.replace(/\/$/, "");
    return staticRoutes[normalizedPath] || normalizedPath || "home";
  };
  
  return getScreenName();
};